module.exports = redcatSdk;


//////////////////
// WEBPACK FOOTER
// external "redcatSdk"
// module id = xH/g
// module chunks = 64